<template>
  <div class="about" :style="{ backgroundImage: `url(${backgroundUrl})` , backgroundRepeat: `no-repeat`  } ">
    <h1 :class="$style.white">This page shows you have applied to a HM event.</h1>
    <h1 :class="$style.white">If any information need to be changed or you need to talk to someone, </h1>
    <h1 :class="$style.white">please call Miss Huang 02-25338082#865 ,or mail to <a href="mailto:gracehuang@ortv.com?subject=天韻邀約問題" style="color: #FFFFFF">gracehuang@ortv.com</a></h1>
    <br>
    <h1></h1>
    <br>
    <h1 :class="$style.orange">您已經完成天韻行程邀約申請。</h1>
    <h1 :class="$style.orange">如果有資料異動或有其他事項需要聯絡：</h1>
    <h1 :class="$style.orange">請致電02-25338082#865 黃小姐，或郵箱 <a href="mailto:gracehuang@ortv.com?subject=天韻邀約問題" style="color: #FFFFFF">gracehuang@ortv.com</a> </h1>
    <br><h1></h1><br><h1></h1><br><h1></h1><br><h1></h1><br>
    <br><h1></h1><br><h1></h1><br><h1></h1><br><h1></h1><br>
    <br><h1></h1><br><h1></h1><br><h1></h1><br><h1></h1><br>
    <h1></h1>
    <!--router-link to="/">
      Chinese
    </router-link-->
  </div>
</template>
<script>
import backgroundUrl from '@/assets/bg_02.png';
export default {
  data() {
    return {
      backgroundUrl
    }
  }
}
</script>

#about{
    background-color: rgb(0, 0, 0);
}

<style module>
.red {
  color: red;
}
.blue {
  color: blue;
}
.orange {
  color: orange;
}
.white {
  color: white;
}
</style>
